import React, { useEffect } from 'react';
import { TrainingHero } from '../components/Training/TrainingHero';
import { ScrollingTagline } from '../components/Training/ScrollingTagline';
import { TrainingGalleryStrip } from '../components/Training/TrainingGalleryStrip';
import { TrainingPositioning } from '../components/Training/TrainingPositioning';
import { TrainingAreas } from '../components/Training/TrainingAreas';
import { SignaturePrograms } from '../components/Training/SignaturePrograms';
import { TrainingFormats } from '../components/Training/TrainingFormats';
import { TrainingPackages } from '../components/Training/TrainingPackages';
import { WhoWeTrain } from '../components/Training/WhoWeTrain';
import { TrainingCommunity } from '../components/Training/TrainingCommunity';
import { TrainingProposalForm } from '../components/Training/TrainingProposalForm';
import { TrainingCTA } from '../components/Training/TrainingCTA';
import { createScrollObserver } from '../utils/animations';
export const Training = () => {
  useEffect(() => {
    // Initialize scroll animations
    const observer = createScrollObserver(entry => {
      entry.target.classList.add('animate-in');
    });
    if (observer) {
      document.querySelectorAll('.scroll-animate').forEach(el => {
        observer.observe(el);
      });
    }
    return () => observer?.disconnect();
  }, []);
  return <div className="overflow-hidden bg-white" data-id="element-4961" data-mp="3ggvwz669pdyk">
      <TrainingHero data-id="element-4962" data-mp="84gks545ulrl" />
      <ScrollingTagline data-id="element-4963" data-mp="83ydmdfymn4w" />
      <TrainingGalleryStrip data-id="element-4964" data-mp="81lzkbdbowx4" />
      <TrainingPositioning data-id="element-4965" data-mp="d31mk8z29di5" />
      <TrainingAreas data-id="element-4966" data-mp="d1702q855dby" />
      <SignaturePrograms data-id="element-4967" data-mp="d1qg21e8drnc" />
      <TrainingFormats data-id="element-4968" data-mp="3v84t7y4odxko" />
      <TrainingPackages data-id="element-4969" data-mp="3v8wf2h8h0gxr" />
      <WhoWeTrain data-id="element-4970" data-mp="3v7cyepiwk3vg" />
      <TrainingCommunity data-id="element-4971" data-mp="3v7v041oc3aar" />
      <TrainingProposalForm data-id="element-4972" data-mp="34c1667yhax5" />
      <TrainingCTA data-id="element-4973" data-mp="33kh9snq11mp" />
    </div>;
};